import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { setRightContent } from '../redux/chat.redux';
import ChatContainer from './chat-container';
import ProfilePanel from './panels/profile-panel';
import AddFriendPanel from './panels/add-friend-panel';
import FriendRequestsPanel from './panels/friend-requests-panel';
import BlockedPanel from './panels/blocked-panel';
import NewGroupPanel from './panels/new-group-panel';
import ContactCard from './panels/contact-card';
import GroupDetailPanel from './panels/group-detail-panel';
import { Contacts as ContactsIcon, Group as GroupIcon } from '@mui/icons-material';

function EmptyState({ icon, text }: { icon: React.ReactElement; text: string }) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f0f1f5',
        color: 'text.secondary',
      }}
    >
      {icon}
      <Typography variant="body1" sx={{ mt: 2 }}>
        {text}
      </Typography>
    </Box>
  );
}

// 右侧详情区:随视图与选中项切换(聊天/名片/群详情/功能面板)
// embedded:移动端详情模式下隐藏面板自带头部(仅外层返回顶栏)
export default function DetailArea({ embedded }: { embedded?: boolean }) {
  const dispatch = useAppDispatch();
  const rightContent = useAppSelector((s) => s.chat.rightContent);
  const view = useAppSelector((s) => s.chat.view);

  switch (rightContent.type) {
    case 'chat':
      return <ChatContainer />;
    case 'panel':
      switch (rightContent.panel) {
        case 'profile':
          return <ProfilePanel embedded={embedded} onClose={() => dispatch(setRightContent({ type: 'none' }))} />;
        case 'add-friend':
          return <AddFriendPanel embedded={embedded} onClose={() => dispatch(setRightContent({ type: 'none' }))} />;
        case 'requests':
          return <FriendRequestsPanel embedded={embedded} onClose={() => dispatch(setRightContent({ type: 'none' }))} />;
        case 'blocked':
          return <BlockedPanel embedded={embedded} onClose={() => dispatch(setRightContent({ type: 'none' }))} />;
        case 'new-group':
          return <NewGroupPanel embedded={embedded} onClose={() => dispatch(setRightContent({ type: 'none' }))} />;
        default:
          return <EmptyState icon={<ContactsIcon sx={{ fontSize: 64, color: 'rgba(39,42,80,0.15)' }} />} text="选择功能查看详情" />;
      }
    case 'contact-card':
      return (
        <ContactCard
          embedded={embedded}
          userId={rightContent.userId}
          onClose={() => dispatch(setRightContent({ type: 'none' }))}
        />
      );
    case 'group-detail':
      return (
        <GroupDetailPanel
          embedded={embedded}
          groupId={rightContent.groupId}
          onClose={() => dispatch(setRightContent({ type: 'none' }))}
        />
      );
    case 'none':
    default:
      return view === 'contacts' ? (
        <EmptyState icon={<ContactsIcon sx={{ fontSize: 64, color: 'rgba(39,42,80,0.15)' }} />} text="从左侧选择联系人查看名片" />
      ) : view === 'groups' ? (
        <EmptyState icon={<GroupIcon sx={{ fontSize: 64, color: 'rgba(39,42,80,0.15)' }} />} text="从左侧选择群聊查看详情" />
      ) : (
        <EmptyState icon={<GroupIcon sx={{ fontSize: 64, color: 'rgba(39,42,80,0.15)' }} />} text="选择会话开始聊天" />
      );
  }
}
